import { capitalizeFirstLetter, DateFormats, formatDateToString } from '@core';
import { GamePostData } from './game-post-data.model';

export const formatGamePost = (data: GamePostData): string => {
  const date: string = capitalizeFirstLetter(formatDateToString(data.startDate, DateFormats.WeekdayFullDate));
  const startTime: string = formatDateToString(data.startDate, DateFormats.Time);
  const endTime: string = formatDateToString(data.endDate, DateFormats.Time);
  const price: string = data.priceAmount && data.priceAmount > 0 ? `${data.priceAmount} zł` : 'DARMOWA';

  const lines: string[] = [data.name, `📅 ${date}`, `🕐 ${startTime} - ${endTime}`, `📍 ${data.locationName}`];

  if (data.totalSlots != null) {
    lines.push(`👥 ${data.occupiedSlots ?? 0}/${data.totalSlots} graczy`);
  }

  lines.push(`📶 Poziom: ${data.level}`);
  lines.push(`💲 ${price}`);

  if (data.description) {
    lines.push(data.description);
  }

  lines.push('', 'Dołącz przez aplikację Orlikfy!', data.url);

  return lines.join('\n');
};

export const futureGamesHeader = (): string => {
  return `Sprawdź, gdzie możesz zagrać w tym tygodniu! 🔥⚽️\n\n`;
};
